import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.6922 7.9422L10.4422 14.1922C10.3841 14.2503 10.3152 14.2964 10.2393 14.3279C10.1634 14.3593 10.0821 14.3755 9.99998 14.3755C9.91785 14.3755 9.83652 14.3593 9.76064 14.3279C9.68477 14.2964 9.61584 14.2503 9.55779 14.1922L3.30779 7.9422C3.19052 7.82492 3.12463 7.66586 3.12463 7.50001C3.12463 7.33416 3.19052 7.1751 3.30779 7.05782C3.42507 6.94055 3.58413 6.87466 3.74998 6.87466C3.91583 6.87466 4.07489 6.94055 4.19217 7.05782L9.99998 12.8664L15.8078 7.05782C15.8659 6.99976 15.9348 6.95369 16.0107 6.92227C16.0865 6.89084 16.1679 6.87466 16.25 6.87466C16.3321 6.87466 16.4134 6.89084 16.4893 6.92227C16.5652 6.95369 16.6341 6.99976 16.6922 7.05782C16.7502 7.11589 16.7963 7.18483 16.8277 7.2607C16.8592 7.33657 16.8753 7.41789 16.8753 7.50001C16.8753 7.58213 16.8592 7.66345 16.8277 7.73932C16.7963 7.81519 16.7502 7.88413 16.6922 7.9422Z",
		fill: "#042914"
	})
});
export { SvgChevronDown as ReactComponent };
